export default __webpack_public_path__ + "static/media/pay_talken_credit.4d2ffa26.png";